const generalFAQs = [
    {
        anchor: `what-is-codespark-academy`,
        question: `What is codeSpark?`,
        answer: `codeSpark is the expanded, subscription-based edition
                of the award-winning coding app, The Foos. In early September 2016,
                The Foos became codeSpark, and all current players must update
                their app in order to use the product.<br /><br />
                codeSpark will have several exciting NEW features that
                are updated regularly with new content every month:
                <ul>
                    <li>New Foos!</li>
                    <li>More puzzles and games</li>
                    <li>Game Kits</li>
                    <li>Personalized Daily Activities</li>
                    <li>Brand New Menu and Map</li>
                    <li>Teacher Dashboard</li>
                    <li>More tutorial videos</li>
                </ul>`
    },
    {
        anchor: `free-trial`,
        question: `Do you offer a free trial of codeSpark?`,
        answer: `The monthly subscription comes with a 7-day free trial. Once the trial
                has ended you will be charged.`
    },
    {
        anchor: `how-many-kids-subscription`,
        question: `How many children may I register per account?`,
        answer: `You can register up to three children on one codeSpark account. You
                can register them after purchasing your subscription. Children can customize
                their avatars and usernames at any time. Multiple children can use codeSpark
                at the same time, provided they are using different devices.`
    },
    {
        anchor: `age-range`,
        question: `For which age range is codeSpark best suited?`,
        answer: `codeSpark is geared toward children ages 3-10, however we&rsquo;ve
                seen kids older than 9 have a blast playing the game (they tend to go through
                the puzzles quickly and then spend most of their time coding levels). We&rsquo;ve also seen
                kids younger than 4 play codeSpark, but they would usually need some help
                from a grown-up.`
    },
    {
        anchor: `private-data`,
        question: `Does codeSpark collect any private data on my child?`,
        answer: `Nope. We are COPPA-compliant and do not collect any private data on our kid coders.`
    },
    {
        anchor: `player-safety`,
        question: `Does codeSpark allow any communication between players?`,
        answer: `Players cannot send any messages to each other. The only communication between players
                is to send a &ldquo;thumbs up&rdquo; or &ldquo;thumbs down&rdquo; rating on a community-created level. There are
                NO OTHER means of communication between players.`
    },
    {
        anchor: `girl-friendly-coding`,
        question: `How is codeSpark girl-friendly?`,
        answer: `Every girl is different, and codeSpark created its girl characters with that thought in mind.
                Girl characters in the game range from queens to police officers to astronauts. We specifically avoided
                girl character tropes in games; our female Foos are never rescued and can solve their own problems
                (with the help of the kid programmer). <br /><br />
                Additionally, we continuously test codeSpark with girl players in order to make sure
                that the characters and gameplay appeal to them. We&rsquo;re happy to say that our game is girl (and boy)
                approved!`
    },
    {
        anchor: `what-does-codespark-academy-teach`,
        question: `What does codeSpark teach?`,
        answer: `codeSpark teaches kids age 4-9 the basics of computer science.
                Kids learn concepts such as:
                <ul>
                    <li>Sequencing</li>
                    <li>Loops</li>
                    <li>Conditional Statements</li>
                    <li>Events</li>
                    <li>Boolean logic &amp; sorting</li>
                    <li>Variables (coming soon)</li>
                </ul>`
    },
    {
      anchor: `what-does-splash-clash-teach`,
      question: `What do kid coders learn from Splash Clash?`,
      answer: `Kid coders primarily practice sequencing in Splash Clash. <br /><br />
              Sequencing is introduced in the puzzle area. While puzzles are great place to begin,
              they’re not as much fun to repeat once you know the solution. <br /><br />
              Enter Splash Clash. In a multiplayer game - against the computer or another player -
              kid coders have fun practicing their skills in ever-changing matches. Each new opponent provides a
              new coding challenge to overcome. Most professional coding is collaborative, so kids can code with a
              friend against the computer. Kids are encouraged to code more, as thinking ahead with longer sequences helps them win.`
    },
    {
      anchor: `play-splash-clash-together`,
      question: `How do we play Splash Clash together?`,
      answer: `Splash Clash can be played with 1 - 4 players on 1 - 4 devices. <br /><br />
              It’s most fun when each player has their own device. Add each device to the same wifi network. Sign in to any
              account on each device and select the “Nearby” option from the Splash Clash Menu. One player will create a match, and
              the others join them. <br /><br />
              codeSpark works across many tablets, phones, and the web. You can use any of these to play Splash Clash together. <br /><br />
              With just one device, you can use the <b>Pass and Play</b> option, where each player codes on the device secretly,
              then all players watch together as a group. <br /><br />
              For kids - or parents - nervous to play against another human, 2 people can play cooperatively against the computer.
              This gets kid coders talking about their code and strategy, which is both educational and fun!`
    },
    {
        anchor: `activities-curriculum`,
        question: `Are there any other activities or curriculum to support codeSpark?`,
        answer: `Yes! We have unplugged activities and a 25-lesson curriculum available for
                download in the &ldquo;Resources&rdquo; section.`
    },
    {
        anchor: `coding-learning-disabilities`,
        question: `My child is a pre-reader/ELL student/has a reading disability. Can I still use codeSpark?`,
        answer: `Yes! codeSpark does not use words to teach coding basics.
                The game is completely visual based, allowing kids of all abilities to play and learn.`
    },
    {
        anchor: `game-kits`,
        question: `What are &ldquo;Game Kits&rdquo;?`,
        answer: `We realized that a lot of kids who start the Foo Studio Game Maker had trouble coming
                up with games to make. Game Kits are &ldquo;paint-by-numbers&rdquo; tutorials that guide kids through
                creating a game - blocks and code will be sketched out for kids to fill in to create some seriously cool games.`
    },
    {
        anchor: `school-availability`,
        question: `Is codeSpark available for schools?`,
        answer: `codeSpark is 100% FREE for verified teachers and librarians of public schools in North America and
                non-profit organizations. To set up a school/teacher account, you need to first set up a codeSpark Teacher
                Dashboard account at <a href="`+ process.env.REACT_APP_DASHBOARD_BASE_URL + `">dashboard.codespark.com</a>.`
    },
    {
        anchor: `contact-us`,
        question: `I have other questions. Is there a contact email?`,
        answer: `If you have any other questions, send an email to our support team
                at <a href="mailto:support@codespark.com">support@codespark.com</a>.
                Our support team is available Monday thru Friday from 9am - 6pm.`
    }
];

const billingFAQs = [
    {
        anchor: `how-much-codespark-academy-subscription`,
        question: `Is codeSpark free?`,
        answer: `You have a 7 day free trial after you agree to the monthly subscription. You
                will be charged once the trial expires.`
    },
    {
        anchor: `why-subscribe`,
        question: `Why a subscription?`,
        answer: `We want to continue teaching and inspiring kids around the world for a long time. The new
                subscription plan is the best way to deliver high-quality and super fun educational content
                that keeps children learning and creating month after month. In addition, we can avoid
                annoying in-game advertisements and in-app purchases.`
    },
    {
        anchor: `billing-frequency`,
        question: `How often will I be billed?`,
        answer: `Your billing cycle is determined by the date that you subscribe as well as the membership
                option you select. For a monthly subscription, your renewal date is one month from your purchase date.`
    },
    {
        anchor: `how-to-cancel`,
        question: `How do I cancel?`,
        answer: `We&rsquo;re sorry to see you go! Our learning app has a ton of different content so please have your
                child explore for all seven days of the trial so they get a chance to solve puzzles, make games
                and learn about automation.<br /><br />
                If after your trial you&rsquo;d still like to cancel your subscription to codeSpark then please
                follow these directions:<br /><br />

                <b>Apple App Store (iOS)</b> - cancel your subscription <a href="https://support.apple.com/en-us/HT202039" target="_blank">here</a>.<br />

                <b>Google Play Store (Android)</b> - cancel your
                subscription <a href="https://support.google.com/payments/answer/6220303?hl=en" target="_blank">here</a>. If the cancellation button does not appear,
                please contact us at <a href="mailto:support@codespark.com">support@codespark.com</a> with your
                Google Play ID from your original e-receipt (the number begins with &ldquo;GPA&rdquo;) so we can manually cancel for you.<br />

                <b>Our website</b> - cancel your subscription by <a href="`+ process.env.REACT_APP_ACCOUNTS_BASE_URL +`/login">logging into your account</a>.`
    },
    {
        anchor: `switching-devices`,
        question: `If I purchase a codeSpark subscription on iOS, will it work on Android (and vice versa)?`,
        answer: `Yes! One codeSpark subscription can be used on either an iOS or Android device.`
    },
    {
        anchor: `gift-subscriptions`,
        question: `Can I gift a subscription?`,
        answer: `Yes! Please visit <a href="`+ process.env.REACT_APP_CODESPARK_BASE_URL +`/gift">our gifting page</a> to get started!`
    },
    {
        anchor: `platform-availablity`,
        question: `For which platforms is codeSpark available?`,
        answer: `codeSpark is available on smart devices that run Apple and Android operating systems.
            You can also play on the web after <a href="`+ process.env.REACT_APP_ACCOUNTS_BASE_URL +`">creating an account and starting a trial.</a>`
    },
    {
        anchor: `device-requirements`,
        question: `What are the minimum device requirements needed to use codeSpark?`,
        answer: `Here are the minimum device requirements to run codeSpark:<br />
                <ul>
                    <li>iOS 11 or higher with 2 GB of RAM or more</li>
                    <li>Android 4.4 KitKat or higher with 1 GB of RAM or more</li>
                    <li>Amazon FireOS with 1 GB of RAM or more</li>
                    <li>Chrome or Firefox on a desktop, laptop, or Chromebook with at least 4 GB of RAM. You may need to close all other apps on some devices</li>
                </ul>`
    },
    {
        anchor: `amazon-kindle`,
        question: `What kind of Amazon Fire/Kindle devices do you support?`,
        answer: `Here are a list of Amazon devices that run codeSpark:<br />
                <ul>
                    <li>Kindle Fire HD (2013)</li>
                    <li>Kindle Fire HDX (2013)</li>
                    <li>Kindle Fire HDX Wan (2013)</li>
                    <li>Kindle Fire HDX 8.9 (2013)</li>
                    <li>Kindle Fire HDX 8.9 Wan (2013, 2014)</li>
                    <li>Fire (2015)</li>
                    <li>Fire 7 (2014, 2017)</li>
                    <li>Fire HD 6 (2014)</li>
                    <li>Fire HD 8 (2015, 2016, 2018)</li>
                    <li>Fire HD 10 (2015, 2017)</li>
                    <li>Fire HDX 8.9 (2014)</li>
                    <li>Fire 7 Kids Edition</li>
                    <li>Fire HD 8 Kids Edition</li>
                </ul>

                Amazon Kindle Fire devices from 2011-2012 are not compatible with our platform due to the fact
                that they run an Android operating system that is too old. We apologize for the inconvenience.`
    },
    {
        anchor: `desktop-computer`,
        question: `Can my child play on desktop?`,
        answer: `Yes! codeSpark is now available on the web. You will first have to <a href="`+ process.env.REACT_APP_ACCOUNTS_BASE_URL +`">create an account and start a trial</a>.`
    },
    {
        anchor: `will-not-load`,
        question: `I&rsquo;ve downloaded codeSpark but it doesn&rsquo;t load. What should I do?`,
        answer: `You may have a firewall in place that is blocking access to codeSpark. Make
                sure to make these allowances in your firewall:<br />
                <ul>
                    <li>gameserver-live2.thefoos.com</li>
                    <li>d2rxtexhquillh.cloudfront.net</li>
                    <li>codespark.com</li>
                    <li>(port 80 and 443 on all)</li>
                </ul>
                If you are still experience problems, email <a href="mailto:support@codespark.com">support@codespark.com</a> with a description
                of the problem, what device/platform you&rsquo;re using, and any screenshots you may have.`
    },
    {
        anchor: `cannot-login`,
        question: `I purchased a subscription but can&rsquo;t login! What do I do?`,
        answer: `If you purchased a subscription, first try using the &ldquo;Restore Purchases&rdquo; option
                on the bottom right of the paywall screen. Our servers should detect your purchase and
                then give you access to the game. You can start playing now or you can create a username
                and password to sign in on multiple devices.<br />
                <br /> To create a username to sign in on multiple devices:<br />
                <ol>
                    <li>Once you see the green play button, press the &ldquo;Parents&rdquo; icon on the top left screen.</li>
                    <li>Enter you birth date.</li>
                    <li>Switch to the &ldquo;Account&rdquo; tab and press &ldquo;Register&rdquo;.</li>
                    <li>Create your username and password.</li>
                </ol>`
    },
    {
        anchor: `imessage-stickers`,
        question: `I saw that codeSpark comes with free iMessage stickers? How do I get them?`,
        answer: `If you&rsquo;ve downloaded the latest version codeSpark onto your iOS device, you
                will also get our fun sticker pack for iMessage. <br /><br />
                Follow these directions to add the codeSpark sticker pack to your Messages:
                <a href="https://support.apple.com/en-us/HT206906" target="_blank">https://support.apple.com/en-us/HT206906</a>`
    },
];

const giftingFAQs = [
    {
        anchor: `gift-subscriber`,
        question: `Can I purchase a gift subscription for myself if I already have a subscription?`,
        answer: `Yes, but if you have an active subscription or trial you will need to make sure you
                to cancel your current trial or subscription so you are not double-charged.`
    },
    {
        anchor: `apply-gift-active-account`,
        question: `How do I apply a gift code to an already active account?`,
        answer: `If you have an active subscription or trial, you will need to make sure you cancel
                so you are not double charged. When your trial or subscription expires you will be able to
                apply your gift code to your current account. Your child&rsquo;s progress will not be lost when
                you apply the new gift subscription.`
    },
    {
        anchor: `redeem-gift`,
        question: `How do I redeem my gift code?`,
        answer: `Please follow these instructions to add your membership to your account.
                <ol>
                    <li>Go to <a href="`+ process.env.REACT_APP_ACCOUNTS_BASE_URL +`/promo">https://accounts.codespark.com/promo</a>.</li>
                    <li>Enter the gift code, click Redeem Code.</li>
                    <li>
                        Enter your email address on the popup that displays.
                        <ul>
                            <li>If you <b>have an account</b>, you will be prompted to <b>login.</b></li>
                            <li>If you <b>do not have an account</b>, you will be prompted to <b>register.</b></li>
                        </ul>
                    </li>
                    <li>Log in or register for an account.</li>
                    <li>On the next page, fill out your name and click Complete Order.</li>
                </ol>

                Your gift code should now be applied to your account. If you continue to experience issues,
                please contact us at <a href="mailto:support@codespark.com">support@codespark.com</a> with your gift code so we can further assist you.`
    },
    {
        anchor: `gift-multiple-kids`,
        question: `Do I have to purchase more than one gift code if I have more than one child?`,
        answer: `Just like our regular subscription, you can have up to three profiles for one account,
                so you&rsquo;ll only need one subscription for up to three children per household.`
    },
    {
        anchor: `gift-iTunes-Google`,
        question: `Can I purchase a gift via iTunes or Google Play Store?`,
        answer: `We do not have the ability to gift subscriptions via app stores. You can only purchase a
                gift subscription here on our website.`
    },
    {
        anchor: `glitch-purchase`,
        question: `Can I just purchase a Glitch?`,
        answer: `Yes! You can purchase a Glitch plush and other codeSpark merchandise at <a href="`+ process.env.REACT_APP_STORE_BASE_URL +`">shop.codespark.com</a>.`
    },
    {
        anchor: `gift-non-US`,
        question: `If I don&rsquo;t live in the USA, can I purchase a lifetime membership gift?`,
        answer: `Yes, you can purchase a Lifetime Membership gift if you live outside of the US. However, we do
                not deliver to addresses outside of the US &amp; Canada, so you will receive the membership gift code but not
                the physical gift package.`
    },
    {
        anchor: `gift-renew`,
        question: `Is the gift subscription auto-renewing?`,
        answer: `Gift subscriptions do not auto-renew. You will only be charged when you make your initial
                purchase and will not be charged at the end of the 6-month or yearly subscription. Lifetime memberships are
                a one-time charge for the entirety of the life of the app.`
    },
    {
        anchor: `compatible-devices`,
        question: `On what devices can gift recipients play codeSpark?`,
        answer: `codeSpark can be run on devices running iOS 11 or higher with 2GB of RAM or more, Android 4.4 or higher
                with 1 GB of RAM or more, an Amazon tablet with 1 GB of RAM or more, or in Chrome or Firefox on a computer with at
                least 4 GB of RAM.`
    },
];

exports.generalFAQs = generalFAQs;
exports.billingFAQs = billingFAQs;
exports.giftingFAQs = giftingFAQs;



// WEBPACK FOOTER //
// ./src/containers/FAQ/faqs.js